// Static mock data for the Crypto Casino admin template.
// Replace these exports with real API calls when wiring a backend.

export const kpis = [
  {
    id: "deposits",
    label: "Total Deposits (30d)",
    value: "$4.82M",
    delta: 12.4,
    series: [22, 28, 26, 34, 31, 40, 38, 46, 44, 52, 49, 58],
    color: "secondary",
  },
  {
    id: "withdrawals",
    label: "Total Withdrawals (30d)",
    value: "$3.11M",
    delta: 6.1,
    series: [18, 20, 19, 24, 22, 27, 25, 30, 29, 33, 31, 36],
    color: "primary",
  },
  {
    id: "ggr",
    label: "Gross Gaming Revenue",
    value: "$1.71M",
    delta: 18.9,
    series: [9, 11, 10, 14, 13, 17, 16, 20, 19, 24, 23, 28],
    color: "warning",
  },
  {
    id: "players",
    label: "Active Players (24h)",
    value: "12,840",
    delta: -2.3,
    series: [60, 58, 62, 59, 64, 61, 66, 63, 60, 58, 57, 55],
    color: "error",
  },
];

export const revenueSeries = [
  { day: "Mon", deposits: 420, withdrawals: 280, ggr: 140 },
  { day: "Tue", deposits: 512, withdrawals: 320, ggr: 192 },
  { day: "Wed", deposits: 478, withdrawals: 305, ggr: 173 },
  { day: "Thu", deposits: 605, withdrawals: 360, ggr: 245 },
  { day: "Fri", deposits: 720, withdrawals: 430, ggr: 290 },
  { day: "Sat", deposits: 890, withdrawals: 520, ggr: 370 },
  { day: "Sun", deposits: 815, withdrawals: 470, ggr: 345 },
];

export const gameMix = [
  { name: "Slots", value: 48, color: "#7c5cff" },
  { name: "Live Casino", value: 23, color: "#00e0b8" },
  { name: "Crash / Originals", value: 17, color: "#ffb020" },
  { name: "Sportsbook", value: 12, color: "#ff5470" },
];

export const cryptoVolume = [
  { coin: "BTC", volume: 1840, color: "#f7931a" },
  { coin: "ETH", volume: 1320, color: "#627eea" },
  { coin: "USDT", volume: 2110, color: "#26a17b" },
  { coin: "SOL", volume: 760, color: "#14f195" },
  { coin: "LTC", volume: 410, color: "#bfbbbb" },
];

export const players = [
  { id: "PL-10293", username: "satoshi_whale", tier: "VIP", country: "🇯🇵 JP", balance: 84210.55, wagered: 1240000, status: "Active", joined: "2024-11-02", kyc: "Verified" },
  { id: "PL-10288", username: "moonshot_max", tier: "Gold", country: "🇩🇪 DE", balance: 12044.10, wagered: 412000, status: "Active", joined: "2025-01-14", kyc: "Verified" },
  { id: "PL-10277", username: "degen_dana", tier: "Silver", country: "🇧🇷 BR", balance: 980.00, wagered: 88500, status: "Active", joined: "2025-02-20", kyc: "Pending" },
  { id: "PL-10261", username: "hodl_harry", tier: "VIP", country: "🇬🇧 GB", balance: 56120.33, wagered: 910000, status: "Active", joined: "2024-09-30", kyc: "Verified" },
  { id: "PL-10255", username: "lucky_lena", tier: "Bronze", country: "🇨🇦 CA", balance: 145.20, wagered: 12300, status: "Suspended", joined: "2025-03-11", kyc: "Pending" },
  { id: "PL-10240", username: "crypto_carl", tier: "Gold", country: "🇦🇺 AU", balance: 9820.75, wagered: 305000, status: "Active", joined: "2024-12-08", kyc: "Verified" },
  { id: "PL-10231", username: "zero_chill", tier: "Silver", country: "🇫🇷 FR", balance: 2310.00, wagered: 64200, status: "Banned", joined: "2025-01-29", kyc: "Rejected" },
  { id: "PL-10219", username: "vegas_vik", tier: "VIP", country: "🇺🇸 US", balance: 102400.00, wagered: 2010000, status: "Active", joined: "2024-08-17", kyc: "Verified" },
  { id: "PL-10202", username: "spin_sara", tier: "Bronze", country: "🇮🇳 IN", balance: 56.40, wagered: 4200, status: "Active", joined: "2025-04-02", kyc: "Pending" },
  { id: "PL-10198", username: "block_betty", tier: "Gold", country: "🇳🇬 NG", balance: 7430.90, wagered: 221000, status: "Active", joined: "2025-02-01", kyc: "Verified" },
];

export const transactions = [
  { id: "TX-89234", player: "satoshi_whale", type: "Deposit", coin: "BTC", amount: 1.2, usd: 78240, status: "Completed", time: "2026-06-25 09:42", hash: "0x9f3a…b71c" },
  { id: "TX-89233", player: "moonshot_max", type: "Withdrawal", coin: "ETH", amount: 4.5, usd: 14310, status: "Pending", time: "2026-06-25 09:31", hash: "0x12ce…aa90" },
  { id: "TX-89231", player: "vegas_vik", type: "Deposit", coin: "USDT", amount: 25000, usd: 25000, status: "Completed", time: "2026-06-25 09:18", hash: "0x77bd…1f2e" },
  { id: "TX-89228", player: "degen_dana", type: "Withdrawal", coin: "SOL", amount: 120, usd: 18600, status: "Review", time: "2026-06-25 08:55", hash: "0x4a01…cc73" },
  { id: "TX-89225", player: "hodl_harry", type: "Deposit", coin: "BTC", amount: 0.35, usd: 22820, status: "Completed", time: "2026-06-25 08:40", hash: "0xab33…9d10" },
  { id: "TX-89221", player: "crypto_carl", type: "Withdrawal", coin: "LTC", amount: 60, usd: 5040, status: "Failed", time: "2026-06-25 08:12", hash: "0x0e5f…7b22" },
  { id: "TX-89218", player: "block_betty", type: "Deposit", coin: "ETH", amount: 2.1, usd: 6678, status: "Completed", time: "2026-06-25 07:59", hash: "0x88aa…3c41" },
  { id: "TX-89214", player: "spin_sara", type: "Deposit", coin: "USDT", amount: 50, usd: 50, status: "Completed", time: "2026-06-25 07:30", hash: "0x991b…0fae" },
];

export const games = [
  { id: 1, name: "Sweet Bonanza", provider: "Pragmatic Play", category: "Slots", rtp: 96.5, bets24h: 184200, ggr: 41200, hot: true },
  { id: 2, name: "Crazy Time", provider: "Evolution", category: "Live Casino", rtp: 95.4, bets24h: 142300, ggr: 38900, hot: true },
  { id: 3, name: "Crash X", provider: "Originals", category: "Crash", rtp: 99.0, bets24h: 220100, ggr: 22500, hot: true },
  { id: 4, name: "Gates of Olympus", provider: "Pragmatic Play", category: "Slots", rtp: 96.5, bets24h: 167400, ggr: 35100, hot: false },
  { id: 5, name: "Lightning Roulette", provider: "Evolution", category: "Live Casino", rtp: 97.3, bets24h: 98700, ggr: 19800, hot: false },
  { id: 6, name: "Plinko", provider: "Originals", category: "Crash", rtp: 98.5, bets24h: 131000, ggr: 14200, hot: true },
  { id: 7, name: "Book of Dead", provider: "Play'n GO", category: "Slots", rtp: 96.2, bets24h: 76500, ggr: 16700, hot: false },
  { id: 8, name: "Blackjack VIP", provider: "Evolution", category: "Live Casino", rtp: 99.3, bets24h: 54300, ggr: 9100, hot: false },
];

export const bonuses = [
  { id: "BN-01", name: "Welcome 200% up to 1 BTC", type: "Deposit Match", status: "Active", claims: 3240, budget: 250000, spent: 162400 },
  { id: "BN-02", name: "Weekend Reload 50%", type: "Reload", status: "Active", claims: 1820, budget: 80000, spent: 41200 },
  { id: "BN-03", name: "Free Spins — Sweet Bonanza", type: "Free Spins", status: "Scheduled", claims: 0, budget: 30000, spent: 0 },
  { id: "BN-04", name: "Cashback Tuesdays 10%", type: "Cashback", status: "Active", claims: 5410, budget: 120000, spent: 93800 },
  { id: "BN-05", name: "VIP Rakeback", type: "Rakeback", status: "Active", claims: 412, budget: 200000, spent: 118900 },
  { id: "BN-06", name: "Crypto Lottery Draw", type: "Lottery", status: "Ended", claims: 9800, budget: 50000, spent: 50000 },
];

export const affiliates = [
  { id: "AF-220", name: "StreamKingTV", referrals: 1840, deposits: 612000, commission: 61200, tier: "Diamond" },
  { id: "AF-198", name: "CryptoGuru", referrals: 920, deposits: 288000, commission: 28800, tier: "Platinum" },
  { id: "AF-176", name: "SlotSensei", referrals: 540, deposits: 141000, commission: 14100, tier: "Gold" },
  { id: "AF-154", name: "BetBuddies", referrals: 310, deposits: 78000, commission: 7800, tier: "Silver" },
  { id: "AF-133", name: "DegenDaily", referrals: 205, deposits: 49000, commission: 4900, tier: "Silver" },
];

export const liveFeed = [
  { id: 1, who: "vegas_vik", action: "won", amount: "$24,500 on Crash X", time: "12s ago", kind: "win" },
  { id: 2, who: "satoshi_whale", action: "deposited", amount: "1.2 BTC", time: "1m ago", kind: "deposit" },
  { id: 3, who: "moonshot_max", action: "requested withdrawal", amount: "4.5 ETH", time: "3m ago", kind: "withdrawal" },
  { id: 4, who: "lucky_lena", action: "flagged", amount: "by risk engine", time: "5m ago", kind: "alert" },
  { id: 5, who: "block_betty", action: "claimed", amount: "Welcome Bonus", time: "8m ago", kind: "bonus" },
  { id: 6, who: "degen_dana", action: "won", amount: "$3,120 on Plinko", time: "11m ago", kind: "win" },
];

/* ===================== Monitor & Audience mock data ===================== */

// Games analytics (P&L, RTP, plays)
export const gamesAnalytics = [
  { name: "Sugar Rush 1000", code: "rlx.sgm.sg_042", wagered: 1240000, pnl: 142300, rtp: 95.2, plays: 21800, tag: "top" },
  { name: "Gates of Olympus", code: "gates_olympus_92", wagered: 1080000, pnl: 121400, rtp: 95.8, plays: 18900, tag: "top" },
  { name: "Sweet Bonanza", code: "sweet_bonanza_92", wagered: 960000, pnl: 98700, rtp: 96.1, plays: 16400, tag: "ok" },
  { name: "3 Wonders Medusa", code: "3wondersmedusa_94", wagered: 920400, pnl: -80828, rtp: 108.8, plays: 14200, tag: "losing" },
  { name: "Mine Field", code: "rlx.ep.mine_field", wagered: 540000, pnl: -69700, rtp: 112.9, plays: 9800, tag: "losing" },
  { name: "Wild Hike", code: "wildhike_94", wagered: 430000, pnl: -53650, rtp: 112.5, plays: 7600, tag: "losing" },
  { name: "The Easter Catch", code: "rlx.ep.easter_catch", wagered: 300000, pnl: -36144, rtp: 112.0, plays: 5200, tag: "losing" },
  { name: "Sugar Burst", code: "rlx.redrake.sugarburst", wagered: 280000, pnl: -23734, rtp: 108.5, plays: 6100, tag: "losing" },
];

export const biggestWinners = [
  { p: "satoshi_whale", pid: "PL-4471", game: "Gates of Olympus", won: 4200 },
  { p: "hodl_harry", pid: "PL-1187", game: "Sugar Rush 1000", won: 3850 },
  { p: "priya_n", pid: "PL-6633", game: "Sweet Bonanza", won: 2410 },
  { p: "dana_w", pid: "PL-3920", game: "3 Wonders Medusa", won: 1980 },
  { p: "owen_c", pid: "PL-5102", game: "Mine Field", won: 1240 },
];

// Revenue
export const ngrWaterfall = [
  { label: "Cash In", value: 42100, color: "#F0B43D", pct: 100 },
  { label: "− Prize redemptions", value: -11200, color: "#23D6A0", pct: 73 },
  { label: "= GGR", value: 30900, color: "#8B6DF0", pct: 73 },
  { label: "− Bonus cost", value: -3900, color: "#5BA8F5", pct: 64 },
  { label: "− Fees / affiliates", value: -12400, color: "#8990B8", pct: 35 },
  { label: "= NGR", value: 14600, color: "#8B6DF0", pct: 35 },
];
export const ngrByChannel = [
  { name: "Affiliates", value: 42, color: "#8B6DF0" },
  { name: "Meta", value: 24, color: "#23D6A0" },
  { name: "Organic", value: 19, color: "#F0B43D" },
  { name: "TikTok", value: 15, color: "#5BA8F5" },
];

// Acquisition
export const acqFunnel = [
  { label: "Visited", value: 18400, color: "#5BA8F5" },
  { label: "Registered", value: 1940, color: "#8B6DF0" },
  { label: "KYC cleared", value: 1480, color: "#23D6A0" },
  { label: "First deposit", value: 212, color: "#F0B43D" },
];
export const ftdsBySource = [
  { source: "Meta", ftds: 88 },
  { source: "Google", ftds: 61 },
  { source: "TikTok", ftds: 54 },
  { source: "Affil", ftds: 97 },
  { source: "Organic", ftds: 32 },
];
export const acqByState = [
  { state: "FL", registrations: 420, ftds: 58, cpf: "$33.10", conv: "13.8%" },
  { state: "TX", registrations: 360, ftds: 44, cpf: "$39.50", conv: "12.2%" },
  { state: "GA", registrations: 280, ftds: 31, cpf: "$41.00", conv: "11.1%" },
  { state: "NY", registrations: 310, ftds: 29, cpf: "$48.20", conv: "9.4%" },
];

// Retention
export const cohort = [
  { day: "Jun 16", d: [100, 52, 41, 33, 28] },
  { day: "Jun 15", d: [100, 55, 44, 35, 30] },
  { day: "Jun 14", d: [100, 49, 38, 31, 26] },
  { day: "Jun 13", d: [100, 58, 46, 38, 33] },
  { day: "Jun 12", d: [100, 51, 40, 32, 27] },
];
export const rtpBySegment = [
  { seg: "New", rtp: 88.4 },
  { seg: "Active", rtp: 91.8 },
  { seg: "Whale", rtp: 94.2 },
  { seg: "VIP", rtp: 96.1 },
  { seg: "At-risk", rtp: 97.9 },
];
export const dormancy = [
  { bucket: "0-3", count: 1420 },
  { bucket: "4-7", count: 880 },
  { bucket: "8-14", count: 612 },
  { bucket: "15-30", count: 410 },
  { bucket: "30+", count: 260 },
];

// Audience — player 360 profiles
export const playerProfiles = [
  { id: "PL-4471", name: "Marcus Reed", email: "m.reed@mail.com", state: "FL", seg: "Whale", lvl: "L4 · High-value", kyc: "Cleared", vip: "Gold", cashIn: 18420, ngr: 6120, gc: 14200, sc: 842, bonus: 3150, scLiab: 512, rtp: 94.2, days: 1, ltd: 24,
    inflight: [["Journey · Onboarding", "complete"], ["Mission · Weekly games", "4 / 5 games"], ["Loyalty · VIP rakeback", "$11.40 this wk"]] },
  { id: "PL-3920", name: "Dana Whitlock", email: "dana.w@mail.com", state: "TX", seg: "VIP", lvl: "L3 · Mid-value", kyc: "Cleared", vip: "Silver", cashIn: 6240, ngr: 2180, gc: 5200, sc: 310, bonus: 900, scLiab: 188, rtp: 96.1, days: 3, ltd: 11,
    inflight: [["Journey · Reactivation", "step 2 of 3"], ["Loyalty · VIP rakeback", "$4.10 this wk"]] },
  { id: "PL-5102", name: "Owen Castillo", email: "ocastillo@mail.com", state: "GA", seg: "Repeat depositor", lvl: "L2 · Growing", kyc: "Pending", vip: "—", cashIn: 980, ngr: 312, gc: 740, sc: 120, bonus: 200, scLiab: 64, rtp: 91.8, days: 2, ltd: 3,
    inflight: [["Journey · Onboarding", "step 3 of 3"], ["Mission · Weekly games", "2 / 5 games"]] },
  { id: "PL-6633", name: "Priya Nair", email: "priya.n@mail.com", state: "NY", seg: "At-risk VIP", lvl: "L3 · Mid-value", kyc: "Cleared", vip: "Silver", cashIn: 9100, ngr: 3010, gc: 200, sc: 55, bonus: 0, scLiab: 30, rtp: 97.9, days: 19, ltd: 14,
    inflight: [["Journey · win-back", "SHADOW — not live"], ["Loyalty · VIP rakeback", "$2.90 this wk"]] },
  { id: "PL-7781", name: "Trevor Goldman", email: "tgold@mail.com", state: "NV", seg: "Active", lvl: "L2 · Growing", kyc: "Cleared", vip: "—", cashIn: 2240, ngr: 760, gc: 3100, sc: 402, bonus: 500, scLiab: 140, rtp: 93, days: 4, ltd: 5,
    inflight: [["Mission · Weekly games", "1 / 5 games"]] },
  { id: "PL-1187", name: "Derek Hsu", email: "dhsu@mail.com", state: "WA", seg: "Whale", lvl: "L4 · High-value", kyc: "Cleared", vip: "Gold", cashIn: 22100, ngr: 7400, gc: 19800, sc: 1180, bonus: 4200, scLiab: 690, rtp: 95.5, days: 1, ltd: 29,
    inflight: [["Mission · Weekly games", "5 / 5 ✓"], ["Loyalty · VIP rakeback", "$18.20 this wk"]] },
];

export const segments = [
  { name: "Whales ($5k+ cash-in)", count: 84, def: "lifetime_cash_in ≥ 5000", color: "#F0B43D" },
  { name: "At-risk VIPs", count: 41, def: "VIP AND days_since_deposit > baseline", color: "#F25C66" },
  { name: "Dormant 14d+", count: 612, def: "days_since_deposit ≥ 14", color: "#5BA8F5" },
  { name: "New depositors (7d)", count: 298, def: "1 deposit, within 7d", color: "#23D6A0" },
  { name: "Non-depositors", count: 1840, def: "0 deposits", color: "#8990B8" },
  { name: "Birthdays tomorrow", count: 147, def: "dob = tomorrow", color: "#E86FB0" },
];

/* ===================== Operate & Intelligence mock data ===================== */

export const kycQueue = [
  { id: "KYC-2231", player: "Owen Castillo", pid: "PL-5102", level: "L2 Identity", docs: "Passport + Selfie", risk: "Low", sla: "46m" },
  { id: "KYC-2230", player: "Sofia Alvarez", pid: "PL-2210", level: "L2 Identity", docs: "Driver License", risk: "Low", sla: "29m" },
  { id: "KYC-2228", player: "Greg Mann", pid: "PL-4410", level: "L3 Source-of-funds", docs: "Bank statement", risk: "Medium", sla: "2h" },
];

export const withdrawalQueue = [
  { id: "WD-8841", player: "Marcus Reed", pid: "PL-4471", amount: 1250, kyc: true, risk: "Low", maker: true },
  { id: "WD-8839", player: "Priya Nair", pid: "PL-6633", amount: 420, kyc: true, risk: "Low", maker: false },
  { id: "WD-8836", player: "Trevor Goldman", pid: "PL-7781", amount: 680, kyc: true, risk: "Medium", maker: false },
  { id: "WD-8835", player: "Derek Hsu", pid: "PL-1187", amount: 3100, kyc: true, risk: "High", maker: true },
];

export const riskSignals = [
  { p: "Derek Hsu", pid: "PL-1187", type: "multi_acct", score: 0.88, detail: "3 accounts share device + payment fingerprint" },
  { p: "Trevor Goldman", pid: "PL-7781", type: "velocity", score: 0.64, detail: "12 deposits in 40m" },
  { p: "Anon-5530", pid: "PL-5530", type: "bonus_abuse", score: 0.79, detail: "Bonus-only play, zero GC purchase, redemption attempt" },
  { p: "User 73486", pid: "PL-7348", type: "large_tx", score: 0.55, detail: "$299.99 single tx — 800k GC package, new payment method" },
];

export const channels = [
  { ch: "Meta", spend: 4200, ftd: 88, cpf: 47.7, trend: "up", rec: "+$25/day" },
  { ch: "Google", spend: 2600, ftd: 61, cpf: 42.6, trend: "flat", rec: "hold" },
  { ch: "TikTok", spend: 1800, ftd: 54, cpf: 33.3, trend: "up", rec: "+$15/day" },
  { ch: "Affiliates", spend: 3100, ftd: 97, cpf: 31.9, trend: "up", rec: "hold" },
];

export const aiRecs = [
  { txt: "Scale First-deposit cliff +25% — +11% incremental lift vs holdout, budget 63% used.", impact: "+~$2,400 influenced / wk", action: "Scale offer" },
  { txt: "Pause Hot-state reinvest — budget fully spent, paused, zero lift recovered.", impact: "Frees $8k budget", action: "Reallocate" },
  { txt: "27,497 KYC pending — clearing top 5% by deposit intent unblocks est. $9k deposits.", impact: "+~$9k unblocked", action: "Prioritise KYC" },
  { txt: "3 Wonders Medusa running -$80.8k P&L (RTP 108.8%) — review config or weight down.", impact: "Stop bleed", action: "Review game" },
  { txt: "147 birthdays tomorrow — queue birthday reward to engage before they lapse.", impact: "+~$1,100 deposits", action: "Queue offer" },
];

export const aiSummary = [
  ["🚨 Risk flags", ["528 failed transactions today ($574) — chargeback exposure.", "1 velocity user (PL-7781): 12 tx in 40m.", "1 large tx $299.99 (800k GC package, new method).", "KYC backlog 27,497 blocking deposits."]],
  ["⚡ Priority actions", ["Investigate chargebacks + velocity user (urgent).", "Clear top-intent slice of KYC backlog.", "Review losing games — 3 Wonders Medusa, Mine Field.", "Monitor large transactions for fraud."]],
  ["💰 Revenue", ["Cash-in $42.1k, 84% of $50k target; projected EOD $58.4k.", "Top packages: 800k GC ($299.99), 200k GC ($159.98).", "NGR $14.6k, +12% vs avg."]],
  ["👥 Players", ["Eligible DAU 3,853 (40.4% conversion); 27 new signups.", "147 birthdays tomorrow — outreach opportunity.", "VIP Gold tier = 41% of NGR (concentration risk)."]],
  ["🎰 Game P&L", ["House net P&L $771.9k — edge holding overall.", "5 games losing: Medusa -$80.8k, Mine Field -$69.7k, Wild Hike -$53.7k.", "Top by wagering: Sugar Rush, Gates of Olympus."]],
];

export const auditLog = [
  { actor: "NJ", action: "Grant SC", target: "PL-3920", time: "18:41:02", reason: "Goodwill — delayed withdrawal" },
  { actor: "S.Kaur", action: "Approve withdrawal", target: "WD-8830", time: "18:38:55", reason: "KYC cleared, low risk" },
  { actor: "Brain", action: "Decision · offer won slot", target: "Big-win celebration → PL-4471", time: "18:37:10", reason: "Highest priority survivor (3 competed)" },
  { actor: "R.Singh", action: "Risk freeze", target: "PL-5530", time: "18:31:44", reason: "Bonus abuse score 0.79" },
  { actor: "NJ", action: "Pause offer", target: "Hot-state reinvest", time: "18:20:01", reason: "Budget spent" },
];

export const guardrails = [
  ["Max offers / player / day", "3"], ["Max offers / player / week", "12"], ["Suppress after dismissals", "2 in a row"],
  ["One offer per slot", "On"], ["RG: deposit/spend limits", "Enforced"], ["RG: self-exclusion", "Enforced"],
  ["Buy-limit ceiling", "Enforced"], ["KYC gate on redemption", "Enforced"],
];

export const budgetPacing = [
  ["First-deposit cliff", 5040, 8000, "live"], ["Weekend coin boost", 13200, 15000, "live"],
  ["Hot-state reinvest", 8000, 8000, "paused"], ["Loss cashback", 2100, 4000, "live"],
];

export const roles = [
  ["Viewer", "dashboards"], ["Analyst", "+ build offers/journeys (SHADOW)"], ["CRM Op", "+ enable offers, bounded grants"],
  ["Pay/KYC", "+ approve KYC & withdrawals"], ["Risk", "+ freeze/link/ban"], ["Admin", "+ budgets, guardrails, states"],
];
